
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.932 1.429h1.916L2.676 18.57H.583c-.242 0-.45.18-.498.43l-.068.358c-.064.331.177.641.498.641h5.458c.242 0 .451-.18.499-.43l.068-.357c.063-.332-.177-.642-.498-.642H4.126L7.298 1.43h2.119c.242 0 .45-.18.498-.43L9.984.64C10.047.31 9.806 0 9.485 0H4c-.242 0-.45.18-.498.43l-.069.357c-.063.332.178.642.499.642z","fill":"#262626"}})])
          )
        }
      }
    